import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

export const staticStyle = {
  box1Marg: { horizontal: 'auto', top: '0px', bottom: 'small' },
  box1Pad: { horizontal: 'medium', vertical: 'small' },
}

export const verticalStyle = { vertical: 'small' }

export const QuestionAnswerBoxContainer = styled(Box)`
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
`
